var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCornerGrab = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(9.231 9.231)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(4.615 9.231)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(0 9.231)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(9.231 4.615)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(4.615 4.615)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.385,
    cy: 1.385,
    rx: 1.385,
    ry: 1.385,
    transform: "translate(9.231)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCornerGrab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/corner-grab.0c677ce56234f09afd07bf93046abf52.svg";